export default "query GiftCardStatus($code:String!,$pin:String!){data:giftCardStatus(code:$code,pin:$pin){maskedCode balance validUntil}}"